import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import stylesListicle from "./styles.m.css";
import Icon from "../../../../atoms/icon";
import { DfpAd } from "../../../../atoms/dfp-ad";
import ImageCaption from "../shared/elements/image-caption";
import ResponsiveImageWithFallback from "../../../../atoms/responsive-image-with-fallback";
import { generateImageSources } from "../../../../utils/utils";
import { isPremium } from "../../../../../../isomorphic/data/story";
import VuukleCommentCount from "../shared/vuukle/count";
import { HeroImage } from "../shared/hero-image";
import { GA } from "../../../../../integrations";

import Cookies from "universal-cookie";
import { triggerwruEvent } from "../../../../../api";
const cookies = new Cookies();

const ListicleStoryImageElement = ({ element }) => {
  return (
    <div className={`${stylesListicle["listicle-image"]}`}>
      <ResponsiveImageWithFallback
        className={stylesListicle["image-listicle"]}
        slug={element["image-s3-key"]}
        metadata={element["image-metadata"]}
        alt={element["image-caption"]}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [16, 9], screenWidthCoverage: 1 },
          { aspectRatio: [16, 9], screenWidthCoverage: 0.5 }
        )}
      />
      <ImageCaption element={element} />
    </div>
  );
};

ListicleStoryImageElement.propTypes = {
  element: {
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.string,
    "image-caption": PropTypes.string,
    "image-attribution": PropTypes.string
  }
};

class ListicleStory extends Component {
  constructor(props) {
    super(props);
    const renderReadMore = get(props, ["READMORE_ENABLE"]);
    this.state = {
      isOpened: !renderReadMore || false,
      story: {}
    };
    this.outerarticle = React.createRef();
  }

  toggleBox = (Id, commentTrigger = false) => {
    const parentStory = cookies.get("story-view");
    window.scrollTo({
      top: this.outerarticle.current.offsetTop - 50
    });
    this.setState(oldState => ({ isOpened: !oldState.isOpened }));
    if (!this.state.isOpened) {
      global.app.maybeSetUrl(
        "/" + this.props.story.slug + "?artfrm=" + this.props.versionStat,
        get(this.props, ["story", "seo", "meta-title"], this.props.story.headline)
      );
      GA.customEvent(`feed_click_${this.props.versionStat}`, `${this.props.index}`, parentStory.headline);
      this.props.fireVirtualPageView();
      triggerwruEvent(this.props.story.id, cookies.get("thinmint"), "STORY_VIEW_EVENT");
      if (this.props.versionStat === "v3")
        triggerwruEvent(this.props.story.id, cookies.get("thinmint"), "RECOMMENDATION_VIEW_EVENT");
    }
    this.props.checkInfoStatus({ id: Id, status: !this.state.isOpened });
  };

  commentTriggerEvent = () => {
    const ID = get(this.props, ["story", "id"], () => null);
    this.toggleBox(ID, true);
  };

  render() {
    const props = this.props;
    const { isOpened } = this.state;
    const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
    const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
    const renderFooter = get(props, ["renderFooter"], () => null);
    const renderfloatingBar = get(props, ["renderfloatingBar"], () => null);
    const renderStoryNewsletter = get(props, ["renderStoryNewsletter"], () => null);
    const cardsToBeNumbered = get(props, ["story", "cards"], []).filter(card => card["card-type"] !== "introduction")
      .length;
    let cardIndex = props.story["bullet-type"] === "123" ? 1 : 0;
    const getStorycardLength = get(props, ["story", "cards"], () => null).length;
    const renderSocialMediaForMobile = get(props, ["renderSocialMediaForMobile"], () => null);
    const renderPremiumCard = get(props, ["renderPremiumCard"], () => null);
    const renderSecondaryCard = get(props, ["renderSecondaryCard"], () => null);
    const renderReadMore = get(props, ["READMORE_ENABLE"]);
    const storyHeadline = get(props, ["story", "subheadline"], () => null);
    const StoryId = get(props, ["story", "id"], () => null);

    const renderBullet = card => {
      if (card["card-type"] !== "introduction") {
        return (
          <div className={stylesListicle["bullet"]}>
            {props.story["bullet-type"] === "123" ? (
              <span className={stylesListicle["bullet-text"]}>{cardIndex++}</span>
            ) : props.story["bullet-type"] === "321" ? (
              <span className={stylesListicle["bullet-text"]}>{cardsToBeNumbered - cardIndex++}</span>
            ) : (
              <Icon type={"bullet-arrow"} className={stylesListicle["bullet-icon"]} />
            )}
          </div>
        );
      } else {
        return null;
      }
    };

    return (
      <div className={styles["main-content"]} ref={this.outerarticle}>
        <article
          className={`infinity-template ${renderReadMore ? styles["nextstory-sec"] : styles["mainstory-sec"]} ${
            styles["story-body"]
          } js-story`}
        >
          <div onClick={() => !this.state.isOpened && this.toggleBox(StoryId)} style={{ cursor: "pointer" }}>
            {renderHeaderCard({ readMore: isOpened })}
            {!isOpened && renderSecondaryCard()}
            {!isOpened && (
              <HeroImage
                story={props.story}
                className={`${!isOpened ? "closed" : ""} ${renderReadMore ? "remove-margin" : ""}`}
              />
            )}
            <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
          </div>
          {renderPremiumCard()}
          {isOpened && (
            <div className="content-section">
              {props.story.cards.map((card, index) => (
                <React.Fragment key={index}>
                  {index === 1 && renderStoryNewsletter()}
                  {index === 3 &&
                    !isPremium(props.story) && <DfpAd story={props.story} adtype="Inarticle_fork" placement="story" />}
                  <div key={card.id} className={stylesListicle["listicle-card-wrapper"]}>
                    {renderBullet(card, index)}
                    <StoryCard key={card.id} card={card} story={props.story} />
                    {index !== getStorycardLength - 1
                      ? !isPremium(props.story) && <DfpAd story={props.story} adtype="Rectangle" placement="story" />
                      : ""}
                  </div>
                </React.Fragment>
              ))}
              {renderFooter()}
            </div>
          )}
          {!renderReadMore ? (
            isOpened === false ? (
              <div className="story-bottom main-story readmore">
                <div className={`${styles["comments"]} show-desktop`}>
                  {renderSocialMedia("show-desktop")}
                  <a className={`${styles["comments_link"]}`} onClick={() => this.toggleBox(StoryId, true)}>
                    <Icon className="svg-comments" type="newsletter" />
                    <VuukleCommentCount className="vu-comments" storyId={StoryId} />
                  </a>
                </div>
                {renderSocialMediaForMobile({ commentTriggerEvent: this.commentTriggerEvent })}
                <a onClick={() => this.toggleBox(StoryId)} className="expandView">
                  மேலும் படிக்க <Icon type="arrow" />
                </a>
              </div>
            ) : (
              <a onClick={() => this.toggleBox(StoryId)} className="expandView expand-close">
                பின் செல்ல
              </a>
            )
          ) : isOpened === false ? (
            <div className="loadmore-stories">
              <div className="story-bottom next-stories readmore">
                <div className={`${styles["comments"]} show-desktop`}>
                  {renderSocialMedia("show-desktop")}
                  <a className={`${styles["comments_link"]}`} onClick={() => this.toggleBox(StoryId, true)}>
                    <Icon className="svg-comments" type="newsletter" />
                    <VuukleCommentCount className="vu-comments" storyId={StoryId} />
                  </a>
                </div>
                {renderSocialMediaForMobile({ commentTriggerEvent: this.commentTriggerEvent })}
                <a onClick={() => this.toggleBox(StoryId)} className="expandView">
                  மேலும் படிக்க <Icon type="arrow" />
                </a>
              </div>
            </div>
          ) : (
            <a onClick={() => this.toggleBox(StoryId)} className="expandView expand-close">
              பின் செல்ல
            </a>
          )}
        </article>
        {isOpened && renderSocialMedia("show-desktop")}
        {isOpened && renderfloatingBar()}
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      "card-type": PropTypes.string,
      metadata: PropTypes.shape({
        attributes: PropTypes.shape({
          imagealignment: PropTypes.array
        })
      }),
      "story-elements": PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string
        })
      )
    })
  ),
  "linked-stories": PropTypes.any
});
ListicleStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  fireVirtualPageView: PropTypes.func,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  renderSecondaryCard: PropTypes.func,
  index: PropTypes.number
};

export { ListicleStory, ListicleStoryImageElement };
